export function WizardStepHeader({
  step,
  total,
  label,
  title,
  children,
}: {
  step: number;
  total: number;
  label: string;
  title: string;
  children?: React.ReactNode;
}) {
  return (
    <header>
      <div className="flex items-center justify-between gap-4">
        <p className="text-xs font-bold uppercase tracking-wide text-brand-700">
          Step {step} of {total}
        </p>
        <p className="text-xs font-semibold text-muted">{label}</p>
      </div>
      <div className="mt-3 grid grid-cols-4 gap-1.5" aria-hidden>
        {Array.from({ length: total }, (_, index) => (
          <span
            key={index}
            className={`h-1.5 rounded-full ${
              index < step ? "bg-accent" : "bg-border"
            }`}
          />
        ))}
      </div>
      <h1 className="mt-5 font-heading text-2xl font-extrabold leading-tight text-navy sm:text-3xl">
        {title}
      </h1>
      {children ? (
        <div className="mt-3 text-sm leading-6 text-muted">{children}</div>
      ) : null}
    </header>
  );
}
